/**
 * Configuración para gráfico de barras verticales apiladas (100%)
 * Usado para mostrar distribución porcentual de cumplimiento por elemento
 */
export function barHorizontalStacked(data) {
    if (!data || !data.yAxis || !data.series) {
        return {};
    }

    const averages = data.averages || [];
    const pillars = data.pillars || [];
    const isMobile = window.innerWidth < 768;

    const greenName = 'Evidencia suficiente, sistemática y periódica';
    const greenSeriesIndex = (data.series || []).findIndex(s => s.name === greenName);

    return {
        devicePixelRatio: window.devicePixelRatio || 2,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            position: function (point, params, dom, rect, size) {
                const obj = { top: point[1] - size.contentSize[1] - 10 };
                obj.left = point[0] - size.contentSize[0] / 2;

                if (obj.left < 10) obj.left = 10;
                if (obj.left + size.contentSize[0] > size.viewSize[0] - 10) {
                    obj.left = size.viewSize[0] - size.contentSize[0] - 10;
                }

                if (obj.top < 10) {
                    obj.top = point[1] + 10;
                }

                return obj;
            },
            formatter: function(params) {
                if (!Array.isArray(params) || params.length === 0) {
                    return '';
                }

                let result = `<strong>${params[0].name}</strong><br/>`;

                const dataIndex = params[0].dataIndex;
                if (averages[dataIndex]) {
                    result += `<strong>Promedio: ${averages[dataIndex]}</strong><br/><br/>`;
                }

                params.forEach(item => {
                    if (item.seriesName !== 'Promedio' && item.value > 0) {
                        result += `${item.marker} ${item.seriesName}: ${item.value}%<br/>`;
                    }
                });
                return result;
            },
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e2e8f0',
            borderWidth: 1,
            textStyle: {
                color: '#1B212E',
                fontSize: isMobile ? 11 : 13
            },
            padding: isMobile ? 8 : 12,
            confine: true
        },
        legend: {
            data: (data.series || []).map(s => s.name),
            top: 0,
            left: 'center',
            itemWidth: 14,
            itemHeight: 14,
            textStyle: {
                color: '#1B212E',
                fontSize: isMobile ? 10 : 12
            },
            itemGap: 10,
            selected: (data.series || []).reduce((acc, s, idx) => {
                acc[s.name] = idx === greenSeriesIndex;
                return acc;
            }, {})
        },
        grid: {
            left: isMobile ? '8%' : '5%',
            right: isMobile ? '8%' : '5%',
            bottom: isMobile ? '30%' : '20%',
            top: isMobile ? '100px' : '60px',
            containLabel: false
        },
        xAxis: {
            type: 'category',
            data: data.yAxis,
            axisLabel: {
                show: true,
                fontSize: isMobile ? 9 : 10,
                interval: 0,
                rotate: 0,
                width: isMobile ? 100 : 140,
                overflow: 'break',
                lineHeight: 14,
                margin: isMobile ? 25 : 10,
                formatter: function(value, index) {
                    const pillar = pillars.find(p => index >= p.startIndex && index <= p.endIndex);

                    if (pillar) {
                        return `{pillar${pillar.startIndex}|${value}}`;
                    }
                    return value;
                },
                rich: pillars.reduce((acc, pillar) => {
                    acc[`pillar${pillar.startIndex}`] = {
                        color: '#333',
                        backgroundColor: pillar.color + '50',
                        borderTopColor: pillar.color,
                        borderTopWidth: 3,
                        borderRadius: 2,
                        padding: [3, 4, 1, 4]
                    };
                    return acc;
                }, {})
            },
            axisLine: {
                lineStyle: {
                    color: '#e2e8f0'
                }
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            max: 100,
            axisLabel: {
                formatter: '{value}%',
                color: '#999',
                fontSize: 11
            },
            splitLine: {
                lineStyle: {
                    color: '#f0f0f0',
                    type: 'dashed'
                }
            }
        },
        series: data.series.map((serie) => {
            const colorMap = {
                'Cumple': '#5cb85c',
                'No Cumple': '#d9534f',
                'Necesita Mejorar': '#f0ad4e',
                'No Aplica': '#999'
            };

            return {
                ...serie,
                type: serie.type || 'bar',
                barMaxWidth: isMobile ? 30 : 50,
                stack: serie.stack || undefined,
                itemStyle: {
                    ...(serie.itemStyle || {}),
                    color: (serie.itemStyle && serie.itemStyle.color) || colorMap[serie.name] || '#999'
                },
                label: serie.label || { show: false },
                emphasis: serie.emphasis || {
                    focus: 'series',
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.15)',
                        opacity: 0.9
                    }
                }
            };
        })
    };
}
